/* global $ */

import './bootstrap';
import componentLoader from './componentLoader';

import dynamicList from './modules/DynamicList';
import autocompleteSearch from './modules/AutocompleteSearch';
import searchBox from './modules/SearchBox';

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
  },
});

// Extend registered components with project specific components
componentLoader.registeredComponents = Object.assign(componentLoader.registeredComponents, {
  DynamicList: dynamicList,
  AutocompleteSearch: autocompleteSearch,
  SearchBox: searchBox,
});

// Create event listeners for component re-evaluation etc.
componentLoader.createListeners();

// Look up all components in the DOM and initialize them
componentLoader.check();
